import { IState } from 'legacy/lut/store'

export const selectState = (state: IState) => state.partner360.reports
